import getAppState from 'app-state';
import { RcmCartContentAreasSettingsSection } from '@rcm/cart-core';

/**
 * Returns the content for the named content area.
 */
const getContentArea = (areaName: string) =>
    getAppState<RcmCartContentAreasSettingsSection['areas'][string]>(
        'contentAreas.areas.' + areaName,
        ''
    );

export default getContentArea;
